import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client';
import { Queries } from 'apollo';
import useAuthContext from 'hooks/useAuthContext';

// Returns a callback to get the actual image urls. We would ideally be using
// useLazyQuery here but it doesn't return a promise.
const useGetW4ImageUrls = (options = {}) => {
  const context = useAuthContext();
  const client = useApolloClient();
  const getW4ImageUrls = useCallback(
    (documentId, page) =>
      client
        .query({
          query: Queries.getW4DocumentImages,
          variables: { input: { documentId, page } },
          context,
          ...options,
        })
        .then(response =>
          response.data.getW4DocumentImages.map(({ url }) => url),
        ),
    [client, context],
  );
  return getW4ImageUrls;
};

export default useGetW4ImageUrls;
